import React, { useState, useEffect } from 'react';
import logoSrc from '../../assets/images/logo.png';
import styles from './Header.module.css';
import { useLanguage } from '../../context/LanguageContext';
import { useCart } from '../../context/CartContext';

export default function Header({ currentPage }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentDate, setCurrentDate] = useState('');
  const { toggleLanguage, t } = useLanguage();
  const { cartCount } = useCart();

  // 动态生成当前日期（格式：M/DD YYYY）
  useEffect(() => {
    const now = new Date();
    const month = now.getMonth() + 1;
    const day = String(now.getDate()).padStart(2, '0');
    const year = now.getFullYear();
    setCurrentDate(`${month}/${day} ${year}`);
  }, []);

  const navLinks = [
    { id: 'shop', labelKey: 'header.shop' },
    { id: 'draft', labelKey: 'header.draft' },
    { id: 'press', labelKey: 'header.press' },
    { id: 'story', labelKey: 'header.story' },
    { id: 'qa', labelKey: 'header.qa' },
    { id: 'connect', labelKey: 'header.connect' },
    { id: 'stockists', labelKey: 'header.stockists' },
  ];

  return (
    <header className={styles.header}>
      {/* 顶部金色条带 */}
      <div className={styles.topBar}></div>

      <div className={styles.headerContent}>
        {/* Logo 和品牌名 */}
        <div className={styles.logoSection}>
          <a href="/" className={styles.logoLink}>
            <img
              src={logoSrc}
              alt="The Wooden Diary Logo"
              className={styles.logoImage}
            />
            <span className={styles.brandName}>
              THE WOODEN DIARY
            </span>
            <span className={styles.dateText}>{currentDate}</span>
          </a>
        </div>

        {/* 右侧：语言切换 + 购物车 */}
        <div className={styles.rightSection}>
          {/* 语言切换按钮 */}
          <button
            className={styles.langButton}
            onClick={toggleLanguage}
            aria-label="Toggle language"
          >
            {t('language.switch')}
          </button>

          {/* 购物车 - Coming Soon */}
          <a href="/cart" className={styles.cartLink}>
            <span className={styles.cartText}>{t('header.cart')}</span>
            <span className={styles.cartCount}>[{cartCount}]</span>
          </a>
        </div>
      </div>

      {/* 导航栏 */}
      <nav className={styles.nav}>
        {navLinks.map(item => (
          <a
            key={item.id}
            href={`/${item.id}`}
            className={`${styles.navLink} ${currentPage === item.id ? styles.navLinkActive : ''}`}
          >
            {t(item.labelKey)}
          </a>
        ))}
      </nav>

      {/* 移动端汉堡菜单按钮 */}
      <button
        className={styles.menuButton}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* 移动端菜单 */}
      {isMenuOpen && (
        <div className={styles.mobileMenu}>
          {navLinks.map(item => (
            <a
              key={item.id}
              href={`/${item.id}`}
              className={styles.mobileNavLink}
              onClick={() => setIsMenuOpen(false)}
            >
              {t(item.labelKey)}
            </a>
          ))}
          <button
            className={styles.mobileLangButton}
            onClick={() => {
              toggleLanguage();
              setIsMenuOpen(false);
            }}
          >
            {t('language.switch')}
          </button>
        </div>
      )}
    </header>
  );
}